import { VisualIdentity } from './visual-identity';

export class VisualIdentitySerializer {

  fromJson(json: any): VisualIdentity {
    const vi = new VisualIdentity();

    vi.success = json.success;
    vi.data = this.toJson(json.data);
    return vi;
  }

  toJson(vi: VisualIdentity): any {
    if (typeof vi === 'object') {
      return {
        id: vi.id,
        logo: vi.logo,
        institutional_color: vi.institutional_color,
        favicon: vi.favicon,
        background: vi.background,
        changed_by: vi.changed_by,
        last_change: vi.last_change,
        // cascade_change: vi.cascade_change,
      };
    } else {
      return vi;
    }
  }
}
